<template>
  <el-tabs v-model="active" style="width: 100%" :stretch="true">
    <!-- 教程 -->
    <el-tab-pane name="教程">
                <span slot="label">
                  <em class="app-article-tab"/>教程<em class="app-article-tab"/>
                </span>
      <MarkdMain :mark-data="markedData" v-outline="outlineSettings"></MarkdMain>
    </el-tab-pane>
    <!-- 评论 -->
    <el-tab-pane name="评论">
                <span slot="label">
                  <em class="app-article-tab"/>评论<em class="app-article-tab"/>
                </span>
      <Comment></Comment>
    </el-tab-pane>
  </el-tabs>
</template>

<script>

import MarkdMain from "@/views/article/share/components/MarkdMain";
import Comment from "@/views/article/share/components/Comment";

export default {
  name: "MarkedAndCommentPanel",
  components: {
    Comment,
    MarkdMain
  },
  props: {
    markedData: String,
  },
  data() {
    return {
      active: "教程",
      backupTree: [],
      outlineSettings: {
        callback: this.refreshNavTree,
        selectors: ['h1', 'h2', 'h3', 'h4', 'h5'],
        exceptSelector: '[un-nav]'
      }
    }
  },
  watch: {
    active: function (newVal) {
      if (newVal === "评论") {
        this.$parent.$parent.$parent.navTree = []
      } else {
        this.$parent.$parent.$parent.navTree = this.backupTree
      }
    }
  },
  methods: {
    refreshNavTree(treeData) {
      if (treeData !== undefined && treeData.length !== 0) {
        this.$parent.$parent.$parent.navTree = treeData.splice(0, 1)
      }
      this.backupTree = treeData;
    }
  },
}
</script>

<style scoped>

</style>